<main class="eeule-admin mat-typography mat-app-background"
      [ngClass]="(_themeService.themeSubject$ | async)">
  <router-outlet/>
</main>
